module.exports = __webpack_public_path__ + "static/media/thank.4e2c317e.svg";